import React, { useState } from "react";

const cardStyle: React.CSSProperties = {
  background: "#ffffff",
  border: "1px solid #e5e7eb",
  borderRadius: 18,
  padding: "1rem",
};

const labelStyle: React.CSSProperties = {
  display: "grid",
  gap: "0.45rem",
  color: "#334155",
  fontWeight: 600,
};

const inputStyle: React.CSSProperties = {
  width: "100%",
  border: "1px solid #d1d5db",
  borderRadius: 12,
  padding: "0.85rem 0.95rem",
  background: "#fff",
};

const buttonStyle: React.CSSProperties = {
  border: "none",
  borderRadius: 12,
  background: "#111827",
  color: "#fff",
  padding: "0.85rem 1rem",
  fontWeight: 700,
  cursor: "pointer",
};

export default function ProviderPaymentPoliciesPage() {
  const [savedAt, setSavedAt] = useState<string | null>(null);
  const [form, setForm] = useState({
    paymentMode: "deposit",
    defaultDepositPercent: "20",
    cancellationWindowHours: "24",
    lateArrivalGraceMinutes: "10",
    noShowPolicy: "Deposit forfeited after no-show unless manually waived.",
  });

  const updateField =
    (field: keyof typeof form) =>
    (
      event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>,
    ) => {
      setForm((current) => ({ ...current, [field]: event.target.value }));
    };

  const handleSave = (event: React.FormEvent) => {
    event.preventDefault();
    setSavedAt(new Date().toLocaleTimeString());
  };

  return (
    <div style={{ display: "grid", gap: "1rem" }}>
      <section style={cardStyle}>
        <h2 style={{ margin: 0, color: "#0f172a" }}>Payment policies</h2>
        <p style={{ margin: "0.5rem 0 0", color: "#475569", lineHeight: 1.7 }}>
          Configure deposit-only, full-prepayment, cancellation, and no-show rules.
        </p>
      </section>

      <form onSubmit={handleSave} style={{ display: "grid", gap: "1rem" }}>
        <section style={cardStyle}>
          <div
            style={{
              display: "grid",
              gap: "1rem",
              gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
            }}
          >
            <label style={labelStyle}>
              Default payment mode
              <select
                style={inputStyle}
                value={form.paymentMode}
                onChange={updateField("paymentMode")}
              >
                <option value="deposit">Deposit</option>
                <option value="full_prepayment">Full prepayment</option>
                <option value="pay_in_store">Pay in store</option>
              </select>
            </label>

            <label style={labelStyle}>
              Default deposit percent
              <input
                style={inputStyle}
                value={form.defaultDepositPercent}
                onChange={updateField("defaultDepositPercent")}
              />
            </label>

            <label style={labelStyle}>
              Cancellation window (hours)
              <input
                style={inputStyle}
                value={form.cancellationWindowHours}
                onChange={updateField("cancellationWindowHours")}
              />
            </label>

            <label style={labelStyle}>
              Grace minutes
              <input
                style={inputStyle}
                value={form.lateArrivalGraceMinutes}
                onChange={updateField("lateArrivalGraceMinutes")}
              />
            </label>
          </div>
        </section>

        <section style={cardStyle}>
          <label style={labelStyle}>
            No-show and refund policy
            <textarea
              style={{ ...inputStyle, minHeight: 120, resize: "vertical" }}
              value={form.noShowPolicy}
              onChange={updateField("noShowPolicy")}
            />
          </label>
        </section>

        <section style={cardStyle}>
          <div style={{ display: "flex", justifyContent: "space-between", gap: "1rem", flexWrap: "wrap" }}>
            <div style={{ color: "#475569" }}>
              {savedAt ? `Policies saved locally at ${savedAt}` : "No local save yet"}
            </div>
            <button type="submit" style={buttonStyle}>
              Save payment policies
            </button>
          </div>
        </section>
      </form>
    </div>
  );
}